import { ReactNode } from 'react'

import styles from './styles.module.scss'

type Props = {
  eyebrow: string
  title: string
  description?: ReactNode
  variant?: 'default' | 'inverse'
}

const SectionHeading = ({
  eyebrow,
  title,
  description,
  variant = 'default',
}: Props): JSX.Element => (
  <>
    <span
      className={`${styles.eyebrow} ${styles.reveal} ${
        variant === 'inverse' ? styles.inverseEyebrow : ''
      }`}
      data-reveal=""
    >
      {eyebrow}
    </span>
    <h2 className={`${styles.sectionTitle} ${styles.reveal}`} data-reveal="">
      {title}
    </h2>
    {description ? (
      <p
        className={`${styles.sectionSubtitle} ${styles.reveal} ${
          variant === 'inverse' ? styles.inverseSubtitle : ''
        }`}
        data-reveal=""
      >
        {description}
      </p>
    ) : null}
  </>
)

export default SectionHeading
